(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pkj-footer-group]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const toggle = group.querySelector('button');
      const heading = group.querySelector('[data-footer-heading]');
      const links = group.querySelector('ul');
      const mobile = window.matchMedia('(max-width: 749px)');
      const sync = () => {
        toggle.hidden = !mobile.matches;
        heading.hidden = mobile.matches;
        links.hidden = mobile.matches;
        toggle.setAttribute('aria-expanded', String(!mobile.matches));
      };
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        links.hidden = expanded;
      });
      mobile.addEventListener('change', sync);
      sync();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
